const GameAnalytics = {
    init(siteCode) {
      this.siteCode = siteCode;
      this.sessionStartTime = Date.now();
    },
  
    // Core tracking function - kept simple and efficient
    track(event, metadata = {}) {
      if (!window.goatcounter?.count) return;
  
      // Only include metadata if it adds significant analytical value
      const path = Object.keys(metadata).length > 0 
        ? `${event}/${Object.values(metadata).join('/')}`
        : event;
  
      window.goatcounter.count({
        path,
        event: true
      });
    },
  
    trackOnboarding() {
      this.track('onboarding');
      },

    trackDayStart(stats) {
        this.track('day-start', {
        day: stats.day,
        training: stats.training,
        });
    },
      
    trackDayEnd(stats) {
      this.track('day-complete', {
        day: stats.day,
        training: stats.training
      });
    },

    trackGameOver(stats) {
      this.track('game-over', {
        days: stats.daysSurvived,
        training: stats.training
      });
    },

    trackRetry(stats) {
        this.track('retry', {
          days: stats.daysSurvived,
        });
      },
  
    trackRestart(stats) {
        this.track('restart', {
          days: stats.daysSurvived,
        });
      },

    trackShare(source, method) {
      this.track('share', { source, method }); // method: 'native' or 'clipboard'
    },

    trackFooterClick(link) {
    this.track('footer-click', { type: link });
    },

    trackHomeButton(source) {
      this.track('home', { type: source });
      },
    
    trackDismissAppModal() {
      this.track('dismiss-app-modal',);
      },
  };
  
  
  export default GameAnalytics;